export default __webpack_public_path__ + "static/media/plan-pic-bg-h5.4a26e2e1.png";